import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import {
  setModalVisibility,
  setNoInternetConnection
} from 'src/store/modules/actionCreators'

/* --------- reducer --------- */
const initialState = {
  noInternetConnection: false,
  // TODO consider context, hooks
  modalsVisibility: {
    addNewPatient: false,
    addNewReferral: false,
    communication: false
  }
}

export default handleActions(
  {
    [setModalVisibility](state, { payload }) {
      const { modalsVisibility } = state
      return {
        ...state,
        modalsVisibility: {
          ...modalsVisibility,
          ...payload
        }
      }
    },
    [setNoInternetConnection](state, { payload: noInternetConnection }) {
      return {
        ...state,
        noInternetConnection
      }
    }
  },
  initialState
)

/* --------- thunks --------- */
const setModalVisibilityState = (modal, isVisible) => (dispatch) => {
  dispatch(setModalVisibility({ [modal]: isVisible }))
}

export const showModal = (modal) => setModalVisibilityState(modal, true)
export const hideModal = (modal) => setModalVisibilityState(modal, false)

/* --------- selectors --------- */
export const uiSelector = (state) => state.ui
export const modalsVisibilitySelector = createSelector(
  uiSelector,
  (ui) => ui.modalsVisibility
)
export const noInternetConnection$ = createSelector(
  uiSelector,
  ({ noInternetConnection }) => noInternetConnection
)
